<script setup lang="ts">
import LogisticsContracts from '@/views/apps/logistics/LogisticsContracts.vue'
import LogisticsPMPContracts from '@/views/apps/logistics/LogisticsPMPContracts.vue'
import { useTutorialStore } from '@/@core/stores/tutorial'

definePage({
  meta: {
    authenticatedOnly: true,
  },
})

const tutorial = useTutorialStore()

onMounted(() => {
  if (tutorial.shouldAutoShow('welcome', 'v1'))
    tutorial.open('welcome')
})
</script>

<template>
  <VRow class="match-height">
    <VCol
      cols="12"
      md="6"
    >
      <LogisticsContracts />
    </VCol>

    <VCol
      cols="12"
      md="6"
    >
      <LogisticsPMPContracts />
    </VCol>
  </VRow>
</template>
